(function ($) {
    $.nette.ext('newTabPayload', {
        success(payload) {
            if (payload.redirect_new_tab) {
                window.open(payload.redirect_new_tab, '_blank');
            }
        },
    });
}(jQuery));
